const loadMoreBranchesButton = document.querySelector<HTMLElement>(".s-map__branch-button-load-more")

export const filterBranchesCols = (branchType: string) => {
  const branchesCols = document.querySelectorAll<HTMLElement>(".js-map-branch-item")
  branchesCols.forEach((col) => {
    const branch = col.querySelector<HTMLElement>(".i-map-branch")
    col.classList.add("d-none")

    if (branch && branch.dataset.type == branchType) col.classList.remove("d-none")
  })

  branchesColsListing()
  if (loadMoreBranchesButton) loadMoreBranchesButton.dataset.shownItems = String(10)
}

export const limitBranchesList = () => {
  branchesColsListing()
  if (loadMoreBranchesButton) loadMoreBranchesButton.dataset.shownItems = String(10)
}

const branchesColsListing = (count?: number) => {
  const branchesCols = document.querySelectorAll<HTMLElement>(".js-map-branch-item:not(.d-none)")
  const limit = count ? count : 10
  if (branchesCols.length > limit) {
    loadMoreBranchesButton?.classList.remove("d-none")
  }else if (branchesCols.length <= limit) {
    loadMoreBranchesButton?.classList.add("d-none")
  }

  branchesCols?.forEach((col, index) => {
    if (index >= limit) {
      col.classList.add("--hidden")
    } else {
      col.classList.remove("--hidden")
    }
  })
}

loadMoreBranchesButton?.addEventListener("click", (event) => {
  event.preventDefault

  let shownItems = Number(loadMoreBranchesButton.dataset.shownItems)
  shownItems += 10
  loadMoreBranchesButton.dataset.shownItems = String(shownItems)
  branchesColsListing(shownItems)
})
